import React, { createContext, useContext, useState } from 'react';

const ProductContext = createContext();

export const useProducts = () => {
  const context = useContext(ProductContext);
  if (!context) {
    throw new Error('useProducts must be used within ProductProvider');
  }
  return context;
};

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [metalPrices, setMetalPrices] = useState({
    gold: 5200,
    silver: 75
  });

  const addProduct = (product) => {
    const newProduct = {
      ...product,
      id: Date.now(),
    };
    setProducts([...products, newProduct]);
  };

  const updateProduct = (updatedProduct) => {
    setProducts(products.map(p => 
      p.id === updatedProduct.id ? updatedProduct : p
    ));
  };

  const updateMetalPrices = (newPrices) => {
    setMetalPrices(newPrices);
  };

  const deleteProduct = (productId) => {
    setProducts(products.filter(p => p.id !== productId));
  };

  return (
    <ProductContext.Provider value={{
      products,
      metalPrices,
      addProduct,
      updateProduct,
      deleteProduct,
      updateMetalPrices
    }}>
      {children}
    </ProductContext.Provider>
  );
};